export default {"src":"/_next/static/media/forward-some-hero.f23d938d.svg","height":171,"width":300,"blurWidth":0,"blurHeight":0};